import React, { useEffect } from 'react';
import { IPaymentReceipt } from '@components/Sura/PaymentReceipt/types';
import useStyles from '@components/Sura/PaymentReceipt/styles';
import { Button, Grid, Typography, CircularProgress } from '@material-ui/core';
import useStore from '@hooks/useStore';
import { observer } from 'mobx-react';

const PaymentReceipt: React.FC<IPaymentReceipt> = () => {
  const { links, sura, ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const contracts = links.paymentLink.sura.contracts;
  const externalRefId = links.paymentLink.externalRefId;
  const isLoading = sura.flag;

  const handlePayOther = () => {
    window.location.href = links.paymentLink.settings.redirectUrl;
  };

  const handleDownloadFile = () => {
    const linkSource = `data:application/pdf;base64,${sura.proofPayment}`;
    const downloadLink = document.createElement('a');
    const fileName = sura.proofPaymentFileName || `Recibo_Poliza#${contracts[0].policyId}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleSendReceipt = () => {
    sura.setStep(4);
    sura.setSendReceipt(true);
  };

  const Iframe: React.FC = () => (
    <div className={css.divIframe}>
      {isLoading ? (
        <CircularProgress className={css.progress} />
      ) : (
        <iframe
          src={`data:application/pdf;base64,${sura.proofPayment}`}
          width={ui.isMobileScreen ? '382px' : '100%'}
          height={ui.isMobileScreen ? '280px' : '700px'}
        />
      )}
    </div>
  );

  const PaymentDetail: React.FC = () => (
    <div className={css.divText}>
      <Typography className={css.labelReady}>¡Listo!</Typography>
      <Typography className={css.labelPolicy}>Hemos recibido el pago de tu póliza</Typography>
      <div className={css.divNumberPolicy}>
        <Typography className={css.labelPolicy}>
          Número de póliza{contracts.length > 1 && 's'}:
        </Typography>
        <div className={css.divReceipts}>
          {contracts.map((contract, index) => (
            <Typography key={index} className={css.labelNumberPolicy}>
              {contract.policyId}
            </Typography>
          ))}
        </div>
      </div>
    </div>
  );

  const ActionsButtons: React.FC = () => (
    <div className={css.divButtons}>
      <Button className={css.sendButton} onClick={handleSendReceipt} disabled={isLoading}>
        Enviar
      </Button>
      <Button className={css.downloadButton} onClick={handleDownloadFile} disabled={isLoading}>
        Descarga
      </Button>
    </div>
  );

  useEffect(() => {
    sura.getProofPayment(externalRefId);
  }, [externalRefId]);

  return (
    <Grid className={css.divReceipt}>
      <div className={css.card}>
        <Grid container className={css.divCard} xs={12} spacing={ui.isMobileScreen ? 1 : 2}>
          <Grid item xs={ui.isMobileScreen ? 12 : 8} className={css.grid}>
            <Typography className={css.labelReceipt}>Comprobante de pago</Typography>
            {ui.isMobileScreen ? <PaymentDetail /> : <Iframe />}
          </Grid>
          <Grid item xs={ui.isMobileScreen ? 12 : 4} className={css.divRight}>
            {ui.isMobileScreen ? (
              <>
                <Iframe /> <ActionsButtons />
              </>
            ) : (
              <>
                <PaymentDetail /> <ActionsButtons />
              </>
            )}
          </Grid>
        </Grid>
        <Grid container className={css.divBottom} xs={12}>
          <Typography className={css.labelThanks}>
            ¡Gracias por confiarnos tu protección y la de tu familia!
          </Typography>
          <Typography className={css.labelSure}>
            Seguros <span className={css.labelSuraLarge}>SURA</span>{' '}
            <span className={css.labelHashtag}>#AsegúratedeVivir</span>
          </Typography>
        </Grid>
      </div>
      <div className={css.divButtonsOther}>
        <Button className={css.buttonPayOther} onClick={handlePayOther}>
          Pagar otra póliza
        </Button>
        <Button className={css.buttonMoreSura}>Conocer más de Seguros Sura</Button>
      </div>
    </Grid>
  );
};

export default observer(PaymentReceipt);
